import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Stack, Typography, Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

/**
 * Modal displayed when a company's registration period has expired.
 * It uses the new UI style and performs a direct logout upon confirmation.
 * * @param {object} props
 * @param {boolean} props.open - Controls the visibility of the modal.
 * @param {function} props.onClose - Function to close the modal (e.g., when clicking X).
 * @param {function} props.onLogoutConfirm - Function to handle the direct logout action.
 * @param {string} props.logoSrc - The source URL/path for the company logo image.
 */
export default function ExpiredRegistrationModal({ open, onClose, onCompanyInfoClick, logoSrc }) {
    // Logout handler for close icon
    const handleLogout = () => {
      localStorage.removeItem('auth_key');
      localStorage.removeItem('companyLoggedIn');
      localStorage.removeItem('company_is_fully_registered');
      localStorage.removeItem('ChatUserId');
      sessionStorage.removeItem('companySessionLoggedIn');
      sessionStorage.removeItem('ChatUserConnection');
      localStorage.removeItem('showSearchSettingsPopups');
      localStorage.removeItem('company_agent_approval_status');
      localStorage.removeItem('first_login');
      localStorage.removeItem('alertNotifyModalFlag');
      localStorage.removeItem('SidebarData');
      localStorage.removeItem('company_uid');
      localStorage.removeItem('jobfullinfo');
      localStorage.removeItem('user_role');
      window.location.href = '/company/login';
    };
  
  const handleConfirm = () => {
    onCompanyInfoClick();
  };

  const handleTennaviClick = () => {
    window.open('https://tayori.com/form/36cc156c10605d824dfbb0fe37447146a780cc16/', '_blank');
  };

  const handleCompanyInfoClick = () => {
    window.location.href = '/company/finalregistration';
  };

  return (
    <Modal
      open={open}
      // Remove onClose to prevent closing
      aria-labelledby="expired-modal-title"
      aria-describedby="expired-modal-description"
      disableEscapeKeyDown
      // Prevent closing by clicking outside
      onClose={() => {}}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90vw', sm: 460 },
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: { xs: 3, sm: 6 },
          textAlign: 'center',
        }}
      >
        {/* Close (X) icon for logout only */}
        {/* <IconButton
          aria-label="logout"
          onClick={handleLogout}
          sx={{ position: 'absolute', top: 8, right: 8, color: '#C62828' }}
        >
          <LogoutIcon />
        </IconButton> */} 

        <Stack spacing={2.5} alignItems="center">
          {/* Logo */}
          {/* <Box aria-hidden>
            <img src={logoSrc} alt="Logo" style={{ width: 100 }} />
          </Box> */}

          {/* Title */}
          <Typography
            id="expired-modal-title"
            component="h2"
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              fontWeight: 700,
              fontSize: { xs: 22, sm: 28 },
              color: '#000000ff',
              letterSpacing: 0.5,
              lineHeight: 1.35,
              mt:2,
            }}
          >
            登録有効期間が終了しました​
          </Typography>

          {/* Body */}
          <Typography
            id="expired-modal-description"
            sx={{
              fontFamily: '"Noto Sans JP", sans-serif',
              fontSize: { xs: 14, sm: 16 },
              lineHeight: 1.8,
              textAlign: 'center',
              mb:3
            }}
          >
            引き続きサービスをご利用いただくには、
            <Box
              component="span"
              sx={{ color: '#CCAA65', fontWeight: 700, cursor: 'pointer' }}
              onClick={handleCompanyInfoClick}
            >
              会社情報
            </Box>
            の <br /> 登録まはた
            <Box
              component="span"
              sx={{ color: '#CCAA65', fontWeight: 700, cursor: 'pointer'}}
              onClick={handleTennaviClick}
            >
              転ナビ事務局
            </Box>
            へお問い合わせください
          </Typography>

        </Stack>
        <Stack direction="row" spacing={2} justifyContent="center" sx={{ mt: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 2, mt: 1 }}>
            <Button
              variant="outlined"
              color="error"
              onClick={handleLogout}
              className="BorderedButton"
              startIcon={<LogoutIcon />}
              sx={{width:160}}
            >
              ログアウト
            </Button>
              <Button 
              variant="contained"
              onClick={handleConfirm}
              className="yellowButton"
              sx={{width:160}}
            >
              会社情報の登録​
            </Button>
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
}

ExpiredRegistrationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onLogoutConfirm: PropTypes.func.isRequired,
  logoSrc: PropTypes.string.isRequired,
};